module.exports = __webpack_public_path__ + "static/media/depression_moderately_severe.d4936f91.svg";